import React, { Component } from 'react';
import _ from 'lodash';
import UrlHelper from "../../url-helper";
import { Header, Table, Icon } from 'semantic-ui-react';
import moment from 'moment';
import semver from 'semver';
import { Link } from 'react-router-dom';


class PackageList extends Component
{
    state = {
        sortKey         : 'status',
        packages        : [],
        sortDirection   : 'ascending',
    };


    componentDidMount()
    {
        const opts = UrlHelper.getLocalSearchParams( this.props.location.search );

        this.props.updatePackageList(
            opts.packageFilter,
            opts.type,
            opts.channel,
            opts.signature
        );
    }


    componentWillReceiveProps( nextProps )
    {
        this.setState(
            () => {
                const { sortKey, sortDirection } = this.state;

                return {
                    sortKey         : sortKey,
                    packages        : this.sortPackages( nextProps.packages, sortKey, sortDirection ),
                    sortDirection   : sortDirection
                };
            }
        );
    }


    componentDidUpdate( prevProps )
    {
        if(
            ( prevProps.location.pathname !== this.props.location.pathname ) ||
            ( prevProps.location.search !== this.props.location.search )
        )
        {
            const opts = UrlHelper.getLocalSearchParams( this.props.location.search );

            this.props.updatePackageList(
                opts.packageFilter,
                opts.type,
                opts.channel,
                opts.signature
            );
        }
    }


    compareNames( a, b )
    {
        const aName = _.get( a, 'data.pkg.name' ),
            bName   = _.get( b, 'data.pkg.name' );

        if( aName < bName )
        {
            return -1;
        }

        if( aName > bName )
        {
            return 1;
        }

        return 0;
    }


    sortPackages( packages, sortKey, sortDirection )
    {
        let sortedPackages = _.cloneDeep( _.isArray( packages ) ? packages : [] );

        if( sortKey === 'data.pkg.version' )
        {
            sortedPackages.sort(
                ( a, b ) => {
                    const aVer  = _.get( a, sortKey, null ),
                        bVer    = _.get( b, sortKey, null );

                    if( semver.lt( aVer, bVer ) === true )
                    {
                        return -1;
                    }

                    if( semver.gt( aVer, bVer ) === true )
                    {
                        return 1;
                    }

                    return this.compareNames( a, b );
                }
            );
        }
        else if( sortKey === 'status' )
        {
            sortedPackages.sort(
                ( a, b ) => {
                    const aStatus   = this.resolveNumericStatus( a ),
                        bStatus     = this.resolveNumericStatus( b );

                    if( aStatus > bStatus )
                    {
                        return 1;
                    }

                    if( aStatus < bStatus )
                    {
                        return -1;
                    }

                    return this.compareNames( a, b );
                }
            );
        }
        else
        {
            sortedPackages = _.sortBy( sortedPackages, [ sortKey ] );
        }

        if( sortDirection === 'descending' )
        {
            sortedPackages.reverse();
        }

        return sortedPackages;
    }


    getViewPackageUrl( packageName )
    {
        const opts = UrlHelper.getLocalSearchParams( this.props.location.search );

        return UrlHelper.getPackageViewUrl(
                packageName,
                opts.type,
                opts.channel,
                opts.signature
            );
    }


    viewPackage( packageName )
    {
        const opts = UrlHelper.getLocalSearchParams( this.props.location.search );

        this.props.history.push(
            UrlHelper.getPackageViewUrl(
                packageName,
                opts.type,
                opts.channel,
                opts.signature
            )
        );
    }


    resolveStatus( pkgReport )
    {
        if( pkgReport.state !== 'generated' )
        {
            return pkgReport.state;
        }

        return pkgReport.data.info.summary.status;
    }


    isStarProject( pkgReport )
    {
        const coverage = _.get( pkgReport, 'data.coverage' );

        return (
            ( _.get( coverage, 'conditionals.covered' ) === _.get( coverage, 'conditionals.total' ) ) &&
            ( _.get( coverage, 'elements.covered' ) === _.get( coverage, 'elements.total' ) ) &&
            ( _.get( coverage, 'methods.covered' ) === _.get( coverage, 'methods.total' ) ) &&
            ( _.get( coverage, 'statements.covered' ) === _.get( coverage, 'statements.total' ) )
        );
    }


    resolveNumericStatus( pkgReport )
    {
        const status = this.resolveStatus( pkgReport );

        if( ( status === 'error' ) || ( status === 'failure' ) )
        {
            return -3;
        }

        if( status === 'warning' )
        {
            return -2;
        }

        /* if( this.isStarProject( pkgReport ) === true )
        {
            return -1;
        } */

        return 0;
    }


    isNegative( pkgReport )
    {
        const status = this.resolveStatus( pkgReport );

        return ( ( status === 'failure' ) || ( status === 'error' ) );
    }


    isPositive( pkgReport )
    {
        const status = this.resolveStatus( pkgReport );

        return ( status === 'ok' );
    }


    isWarning( pkgReport )
    {
        const status = this.resolveStatus( pkgReport );

        return ( status === 'warning' );
    }


    handleSort( key )
    {
        return () => {
            let { sortKey, packages, sortDirection } = this.state;

            if( sortKey !== key )
            {
                sortDirection = 'ascending';
            }
            else
            {
                sortDirection = ( sortDirection === 'ascending' ) ? 'descending' : 'ascending';
            }

            this.setState(
                {
                    sortKey         : key,
                    packages        : this.sortPackages( packages, key, sortDirection ),
                    sortDirection   : sortDirection,
                }
            );
        };
    }


    getIconStyle( pkgReport )
    {
        const status = this.resolveStatus( pkgReport );

        if( ( status === 'failure' ) || ( status === 'error' ) )
        {
            return 'ban';
        }

        if( status === 'warning' )
        {
            return 'warning sign';
        }

        if( this.isStarProject( pkgReport ) === true )
        {
            return 'checkmark';
        }

        return null;
    }


    render()
    {
        const { sortKey, packages, sortDirection } = this.state;

        if( ( !packages ) || ( packages.length === 0 ) )
        {
            return (
                <Header content={'No packages found!'} color={'grey'} disabled={true} icon={'bug'} size={'medium'} textAlign={'center'} />
            )
        }

        const packageList = _.map(
            packages,
            ( pkgReport, index ) => (
                <Table.Row
                    key={_.get( pkgReport, 'data.pkg.name' )}
                    onClick={this.viewPackage.bind( this, _.get( pkgReport, 'data.pkg.name' ) )}
                    warning={this.isWarning( pkgReport )}
                    negative={this.isNegative( pkgReport )}
                >
                    <Table.Cell textAlign={'center'} collapsing={true}><Icon color={this.getIconStyle( pkgReport ) === 'checkmark' ? 'green' : null} name={this.getIconStyle( pkgReport )} /></Table.Cell>
                    <Table.Cell><Link to={this.getViewPackageUrl( _.get( pkgReport, 'data.pkg.name' ) )}>{_.get( pkgReport, 'data.pkg.name' )}</Link></Table.Cell>
                    <Table.Cell>{_.get( pkgReport, 'data.pkg.version' )}</Table.Cell>
                    <Table.Cell>{moment( _.get( pkgReport, 'committedAt' ) ).format( 'lll' )}</Table.Cell>
                    <Table.Cell>{_.get( pkgReport, 'data.info.summary.message' )}</Table.Cell>
                </Table.Row>
             )
        );

        return (
            <Table selectable={true} sortable={true} className={'PackageList'}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell collapsing={true} sorted={sortKey === 'status' ? sortDirection : null} onClick={this.handleSort('status')}></Table.HeaderCell>
                        <Table.HeaderCell sorted={sortKey === 'data.pkg.name' ? sortDirection : null} onClick={this.handleSort('data.pkg.name')}>Package</Table.HeaderCell>
                        <Table.HeaderCell sorted={sortKey === 'data.pkg.version' ? sortDirection : null} onClick={this.handleSort('data.pkg.version')}>Version</Table.HeaderCell>
                        <Table.HeaderCell sorted={sortKey === 'committedAt' ? sortDirection : null} onClick={this.handleSort('committedAt')}>Committed</Table.HeaderCell>
                        <Table.HeaderCell sorted={sortKey === 'data.info.summary.message' ? sortDirection : null} onClick={this.handleSort('data.info.summary.message')}>Notes</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {packageList}
                </Table.Body>
            </Table>
        );
    }
}

export default PackageList;




// WEBPACK FOOTER //
// ./src/lib/components/PackageList/PackageList.js